import { combineReducers } from "redux"
import * as actions from "../actions"

function forecast(state = null, action) {
  switch (action.type) {
    case actions.SET_RAINFALLFORECAST:
      return action.forecast

    default:
      return state
  }
}

function loading(state = 0, action) {
  switch (action.type) {
    case actions.LOADING_STATE:
      return action.loading

    default:
      return state
  }
}

function notifications(state = null, action) {
  switch (action.type) {
    case actions.SET_SCHEDULED_NOTIFICATIONS:
      return action.notifications

    default:
      return state
  }
}

export default combineReducers({
  forecast,
  loading,
  notifications
})
